import { render, staticRenderFns } from "./jkhclb.vue?vue&type=template&id=97db9442&scoped=true&"
import script from "./jkhclb.vue?vue&type=script&lang=js&"
export * from "./jkhclb.vue?vue&type=script&lang=js&"
import style0 from "./jkhclb.vue?vue&type=style&index=0&id=97db9442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97db9442",
  null
  
)

export default component.exports